import * as Yup from "yup";

import {
  CREDENTIAL_FIELD_KEY,
  CREDENTIAL_VALIDATION_MESSAGES,
} from "./credentialUiLabels";
import { isValidEmailFormat } from "./contactEntryValidation";

const NAME_PATTERN = /^[A-Za-z]+(?: [A-Za-z]+)*$/;

export const emailValidation = Yup.string()
  .trim()
  .test("optional-email", "Invalid email format", (value) => {
    const v = String(value ?? "").trim();
    if (!v) return true;
    return isValidEmailFormat(v);
  });

export const passwordValidation = Yup.string()
  .required(CREDENTIAL_VALIDATION_MESSAGES.required)
  .min(8, CREDENTIAL_VALIDATION_MESSAGES.minLength(8))
  .max(128, CREDENTIAL_VALIDATION_MESSAGES.maxLength(128))
  .matches(/^\S*$/, CREDENTIAL_VALIDATION_MESSAGES.noSpaces)
  .matches(/[A-Z]/, CREDENTIAL_VALIDATION_MESSAGES.uppercase)
  .matches(/[a-z]/, CREDENTIAL_VALIDATION_MESSAGES.lowercase)
  .matches(/\d/, CREDENTIAL_VALIDATION_MESSAGES.number)
  .matches(/[@$!%*?&#]/, CREDENTIAL_VALIDATION_MESSAGES.special);

export const confirmPasswordValidation = (
  passwordField: string = CREDENTIAL_FIELD_KEY
) =>
  Yup.string()
    .required(CREDENTIAL_VALIDATION_MESSAGES.confirmRequired)
    .max(128, CREDENTIAL_VALIDATION_MESSAGES.confirmMaxLength(128))
    .matches(/^\S*$/, CREDENTIAL_VALIDATION_MESSAGES.confirmNoSpaces)
    .oneOf([Yup.ref(passwordField)], CREDENTIAL_VALIDATION_MESSAGES.mismatch);

export const phoneValidation = Yup.string()
  .required("Phone number is required")
  .matches(/^[6-9]\d{9}$/, "Enter valid phone number");

export const nameValidation = Yup.string()
  .required("Name is required")
  .min(2, "Name must be at least 2 characters")
  .max(100, "Name must not exceed 100 characters")
  .matches(NAME_PATTERN, "Only alphabets and spaces are allowed.");

export const fullNameValidation = Yup.string()
  .required("Name is required")
  .min(2, "Name must be at least 2 characters")
  .max(100, "Name must not exceed 100 characters")
  .matches(NAME_PATTERN, "Only alphabets and spaces are allowed.");

export const nameLastValidation = Yup.string()
  .required("Last Name is required")
  .min(2, "Last Name must be at least 2 characters")
  .max(100, "Last Name must not exceed 100 characters")
  .matches(NAME_PATTERN, "Only alphabets and spaces are allowed.");

export const firstNameValidation = nameValidation.required("First name is required");
export const lastNameValidation = nameValidation.required("Last name is required");
